import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function useSavedJobs() {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setIds(new Set()); setLoaded(true); return; }
    try {
      const { data } = await api.get("/saves/jobs");
      setIds(new Set(data.saved_ids || []));
    } catch {
      setIds(new Set());
    } finally {
      setLoaded(true);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (jobId) => {
    if (!user) return { needsAuth: true };
    const has = ids.has(jobId);
    // optimistic
    const next = new Set(ids);
    if (has) next.delete(jobId); else next.add(jobId);
    setIds(next);
    try {
      if (has) await api.delete(`/saves/jobs/${jobId}`);
      else await api.post(`/saves/jobs/${jobId}`);
      return { saved: !has };
    } catch (e) {
      // revert
      setIds(ids);
      return { error: true };
    }
  };

  return { savedIds: ids, isSaved: (id) => ids.has(id), toggle, refresh, loaded };
}
